// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cj-a";
export var fulfillmentFormRail = "_cj-9";
export var headerTitleRow = "_cj-c";
export var orderDetailsWrapper = "_cj-7";
export var orderLinkTrigger = "_cj-2";
export var paymentInformationGrid = "_cj-h";
export var paymentSummaryColumn = "_cj-i";
export var shipmentContainer = "_cj-b";
export var shipmentDetailsMainPane = "_cj-8";
export var shipmentNavigationCard = "_cj-5";
export var shipmentNavigationRail = "_cj-3";
export var shipmentNavigationRailHeader = "_cj-4";
export var shipmentSummaryFact = "_cj-e";
export var shipmentSummaryGrid = "_cj-d";
export var shipmentSummaryMetadataRow = "_cj-f";
export var shipmentSummaryTags = "_cj-g";
export var shipmentWorkspace = "_cj-0";
export var shipmentWorkspaceContent = "_cj-6";
export var shipmentWorkspaceHeader = "_cj-1";